module.exports = __webpack_public_path__ + "img/05.aaa14b98.jpg";